import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=fb3cc5f0&"
import script from "./Image.vue?vue&type=script&lang=js&"
export * from "./Image.vue?vue&type=script&lang=js&"
import style0 from "./Image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qhotian/Project/haodf/hb-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3cc5f0')) {
      api.createRecord('fb3cc5f0', component.options)
    } else {
      api.reload('fb3cc5f0', component.options)
    }
    module.hot.accept("./Image.vue?vue&type=template&id=fb3cc5f0&", function () {
      api.rerender('fb3cc5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/detailComp/image/Image.vue"
export default component.exports